import React from 'react';

import { withStyles } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import images from '../../assets';
import { MediaQuery } from '../Common';

import Ratio from 'react-ratio';
import { useTranslation } from 'react-i18next';
import Store from 'store';

export const BlockTitle = ({ children }) => {
  return (
    <>
      <MediaQuery min={900}>
        <div
          style={{
            fontFamily: 'NSCJKrB',
            fontSize: 30,
            color: 'black',
            display: 'flex',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          {children}
        </div>
      </MediaQuery>
      <MediaQuery max={899}>
        <MediaQuery min={700}>
          <div
            style={{
              fontFamily: 'NSCJKrB',
              fontSize: 24,
              color: 'black',
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            {children}
          </div>
        </MediaQuery>
        <MediaQuery max={699}>
          <div
            style={{
              fontFamily: 'NSCJKrB',
              fontSize: 20,
              color: 'black',
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            {children}
           
          </div>
          
        </MediaQuery>
      </MediaQuery>
    </>
  );
};

export const BlockDes = ({ children }) => {
  return (
    <>
      <MediaQuery min={900}>
        <div
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 18,
            color: '#666666',
            display: 'flex',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          {children}
        </div>
      </MediaQuery>
      <MediaQuery max={899}>
        <MediaQuery min={700}>
          <div
            style={{
              fontFamily: 'NSCJKrR',
              fontSize: 14,
              color: '#666666',
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            {children}
          </div>
        </MediaQuery>
        <MediaQuery max={699}>
          <div
            style={{
              fontFamily: 'NSCJKrR',
              fontSize: 12,
              color: '#666666',
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            {children}
          </div>
        </MediaQuery>
      </MediaQuery>
    </>
  );
};

export const BlockBox = ({ children, onClick, cursor }) => {
  return (
    <Ratio ratio={1} style={{ width: 298, margin: 'auto', marginBottom: 10, cursor: cursor ? 'pointer' : '' }}>
      <div
        style={{ width: '100%', height: '100%', borderRadius: 5, overflow: 'hidden', border: '1px solid #dddddd' }}
        onClick={onClick}
      >
        {children}
      </div>
    </Ratio>
  );
};

export const BlockHead = ({ bgcolor, blocktitle, inftext }) => {
  return (
    <div
      style={{
        backgroundColor: bgcolor,
        height: 120,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div style={{ fontFamily: 'NSCJKrB', fontSize: 36, color: 'white' }}>{blocktitle}</div>
      <div style={{ fontFamily: 'NSCJKrR', fontSize: 20, color: 'white' }}>{inftext}</div>
    </div>
  );
};

export const BlockContents = ({ children }) => {
  return (
    <div
      style={{
        height: 178,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {children}
    </div>
  );
};

export const BlockRow = ({ label, value }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: Store.get('lang') === 'kr' && 48   }}>
      <div style={{ fontFamily: 'NSCJKrR', fontSize: 24, color: '#999999', width: 80 }}>{label}</div>
      <div >
        <div style={{ fontFamily: 'NSCJKrM', fontSize: 24, color: 'black', width: 100}}>{value}</div>
        {Store.get('lang') === 'kr' && label == '원화' && <p style={{color:'red', margin: 0, fontSize: 14}}>*VAT 10% 별도</p>}
      </div>
      
    </div>
  );
};

export const BlockReqDes = () => {
  const { t } = useTranslation();
  return (
    <>
      <MediaQuery min={900}>
        <div
          style={{ fontFamily: 'NSCJKrM', fontSize: 18, color: '#e80000', textAlign: 'center', wordBreak: 'keep-all' }}
        >
          * {t('vip_detail')}
        </div>
      </MediaQuery>
      <MediaQuery max={899}>
        <div
          style={{ fontFamily: 'NSCJKrM', fontSize: 14, color: '#e80000', textAlign: 'center', wordBreak: 'keep-all' }}
        >
          * {t('vip_detail')}
        </div>
      </MediaQuery>
    </>
  );
};

export const BlockReqBtn = ({ onClick, children, style }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
    <MediaQuery min={800}>
    <div
        onClick={onClick}
        style={{
          fontFamily: 'NSCJKrB',
          color: 'white',
          fontSize: 18, 
          height: 40,
          padding: '0px 20px',
          backgroundColor: '#fe8b07',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 5,
          ...style,
        }}
      >
        {children}
      </div> 
    </MediaQuery>
    <MediaQuery max={799}>
    <div
        onClick={onClick}
        style={{
          fontFamily: 'NSCJKrB',
          color: 'white',
          fontSize: 16,
          height: 50,
          padding: '0px 20px',
          backgroundColor: '#fe8b07',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 5,
          ...style,
        }}
      >




        {children}
      </div>
      </MediaQuery>


    </div>
  );
};


export const BlockReqV2Btn = ({ onClick, children, style }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
    <MediaQuery min={800}>
    <div
        onClick={onClick}
        style={{
          fontFamily: 'NSCJKrB',
          color: 'white',
          fontSize: 22,
          height: 50,
          padding:'4px 10px 4px 20px',
          backgroundColor: '#fe8b07',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 5,
          ...style,
        }}
      >
        {children}
        <img style = {{padding:'15px'}} src={images.right_arrow}></img>
      </div> 
      
    </MediaQuery>
    <MediaQuery max={799}>
    <div
        onClick={onClick}
        style={{
          fontFamily: 'NSCJKrB',
          color: 'white',
          fontSize: 18,
          height: 50,
          // padding: '0px 20px',
          padding:'4px 20px 4px 20px',
          backgroundColor: '#fe8b07',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 5,
          ...style,
        }}
      >

        {children}
    
      </div>
      </MediaQuery>


    </div>
  );
};



export const CustomHead = withStyles({
  root: {
    borderTop: '3px solid #dddddd',
    borderBottom: '2px solid #dddddd',
    backgroundColor: '#fafafa',
    height: 88,
  },
})(TableHead);

export const CustomBody = withStyles({
  root: {
    borderBottom: '2px solid #dddddd',
  },
})(TableBody);

export const THHCell = ({ children }) => {
  return (
    <>
      <MediaQuery min={800}>
        <TableCell style={{ minWidth: 200 }}>{children}</TableCell>
      </MediaQuery>
      <MediaQuery max={799}>
        <TableCell style={{ minWidth: 160 }}>{children}</TableCell>
      </MediaQuery>
    </>
  );
};

export const THLSCell = ({ headtype, headinf }) => {
  return (
    <>
      <MediaQuery min={800}>
        <TableCell style={{ minWidth: 150 }} align="center">
          <div style={{ fontFamily: 'NSCJKrB', fontSize: 24, color: 'black' }}>{headtype}</div>
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 14, color: '#666666' }}>{headinf}</div>
        </TableCell>
      </MediaQuery>
      <MediaQuery max={799}>
        <TableCell style={{ minWidth: 100 }} align="center">
          <div style={{ fontFamily: 'NSCJKrB', fontSize: 18, color: 'black' }}>{headtype}</div>
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 12, color: '#666666' }}>{headinf}</div>
        </TableCell>
      </MediaQuery>
    </>
  );
};

export const TDLSCell = ({ children }) => {
  return (
    <>
      <MediaQuery min={800}>
        <TableCell>
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 18, color: 'black', wordBreak: 'keep-all' }}>{children}</div>
        </TableCell>
      </MediaQuery>
      <MediaQuery max={799}>
        <TableCell>
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 14, color: 'black', width: 210, wordBreak: 'keep-all' }}>
            {children}
          </div>
        </TableCell>
      </MediaQuery>
    </>
  );
};
